// Shared MUI TextField styling to match the Aceternity "signup form" look:
// dark filled pill input, subtle border, cyan focus ring, light label/text.
export const aceternityTextFieldSx = {
  "& .MuiFilledInput-root": {
    backgroundColor: "#18181b",
    borderRadius: "0.5rem",
    boxShadow: "0 0 0 1px rgba(255,255,255,0.08)",
    overflow: "hidden",
    "&::before, &::after": { display: "none" },
    "&:hover": { backgroundColor: "#1d1d21" },
    "&.Mui-focused": {
      backgroundColor: "#18181b",
      boxShadow: "0 0 0 2px rgba(0,200,255,0.5)",
    },
  },
  "& .MuiFilledInput-input": {
    color: "#f2f2f2",
    padding: "22px 12px 8px",
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.6)",
    "&.Mui-focused": { color: "#00c8ff" },
    "&.Mui-error": { color: "#ff6b6b" },
  },
  "& .MuiFormHelperText-root": {
    color: "rgba(255,255,255,0.5)",
    "&.Mui-error": { color: "#ff6b6b" },
  },
};

export const aceternitySelectSx = {
  backgroundColor: "#18181b",
  borderRadius: "0.5rem",
  color: "#f2f2f2",
  boxShadow: "0 0 0 1px rgba(255,255,255,0.08)",
  "& .MuiSelect-select": { padding: "10px 32px 10px 12px" },
  "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.6)" },
  "&.Mui-focused": { boxShadow: "0 0 0 2px rgba(0,200,255,0.5)" },
};

export const aceternityMenuPaperSx = {
  backgroundColor: "#18181b",
  color: "#f2f2f2",
};

export const aceternityCheckboxSx = {
  color: "rgba(255,255,255,0.4)",
  "&.Mui-checked": { color: "#00c8ff" },
};
